import { Radio, RadioGroup } from "@headlessui/react";

import { JSX } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { IconCheck } from "@/components/icons";
import DateOfBirthInput from "@/components/inputs/DateOfBirthInput";
import Input from "@/components/inputs/Input.tsx";

import { Profile } from "@/api/auth/auth.types";
import { cn } from "@/utils/cn.ts";

const EditProfileForm = ({ profile }: { profile: Profile }): JSX.Element => {
  const { t } = useTranslation();
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={"min-h-[160px] space-y-4 max-md:space-y-3"}>
      <Input
        type={"text"}
        color={"white"}
        register={register}
        validation={{
          required: { value: true, message: t("Form.required") },
        }}
        name={"name"}
        placeholder={t("Form.nickname")}
        errors={errors}
        errorMessage={errors && errors.age ? errors.age.message!.toString() : ""}
      />
      {!profile?.is_kids && (
        <>
          <div className={"space-y-2"}>
            <h2>{t("Gender.choose")}</h2>
            <Controller
              name={"gender"}
              control={control}
              render={({ field }) => (
                <>
                  <RadioGroup
                    {...field}
                    aria-label={t("Gender.choose")}
                    className={"flex flex-col gap-3 max-md:gap-1.5"}
                  >
                    {[
                      { gender: "M", text: t("Gender.male") },
                      { gender: "W", text: t("Gender.female") },
                    ].map((gender) => (
                      <Radio
                        key={gender.gender}
                        as={"button"}
                        type={"button"}
                        value={gender.gender}
                        aria-label={gender.text}
                        className={cn(
                          "w-full rounded-full bg-surface-bright px-6 py-4",
                          "flex items-center justify-between",
                          "outline outline-1 -outline-offset-1 outline-transparent transition-outline",
                          {
                            "outline-orange-1": gender.gender === field.value,
                          },
                        )}
                      >
                        {gender.text}
                        <IconCheck
                          className={cn(
                            "size-6 stroke-orange-1 opacity-0 transition-opacity",
                            field.value === gender.gender && "opacity-100",
                          )}
                        />
                      </Radio>
                    ))}
                  </RadioGroup>
                </>
              )}
            />
          </div>
          <div className={"space-y-2"}>
            <label htmlFor={"age"}>{t("General.age")}</label>
            {/* <Input
          id={"age"}
          type={"number"}
          color={"white"}
          mask={"##"}
          validation={{
            required: { value: true, message: t("Form.required") },
            min: { value: 16, message: t("Profile.age-restriction") },
          }}
          control={control}
          name={"age"}
          placeholder={t("General.age")}
          errors={errors}
          errorMessage={errors && errors.age ? errors.age.message!.toString() : ""}
        /> */}
            <DateOfBirthInput />
          </div>
        </>
      )}
    </div>
  );
};

export default EditProfileForm;
